module.exports = __webpack_public_path__ + "04faff4f68103f9864cc14d0e7147ed9.png";


//////////////////
// WEBPACK FOOTER
// ./work/caoua/img/right.png
// module id = 725
// module chunks = 0